<template>
  <div
    class="side-box"
    :class="{ 'is-open': !collapse, 'no-fixed': !fixed }"
    @mouseenter="footerShow"
    @mouseleave="showFooter = false"
  >
    <div ref="side">
      <recent-actions
        v-model="showPopper"
        placement="right-start"
        :append-to-body="false"
        :popper-options="popperOptions"
        :size-style="sizeStyle"
        @choose-menu="chooseMenu"
        @un-fixed-menu="changeSize"
        @fixed-menu="changeSize"
        @show-menus="changeSize"
        @hide-menus="changeSize"
      />
      <menu-item
        v-for="menu in fixedMenus"
        :key="menu.id"
        placement="right-start"
        :menu="menu"
        @choose-menu="chooseMenu"
        @un-fixed-menu="changeSize"
        @fixed-menu="changeSize"
      />
    </div>
    <!-- <div v-if="!showPopper" class="side-box-footer" :style="footerStyle">
      <i class="fix-icon iconfont icon-mima" @click="changeFixed" />
    </div> -->
  </div>
</template>

<script>
import RecentActions from './components/recent-actions'
import MenuItem from './components/menu-item'
export default {
  components: {
    RecentActions,
    MenuItem
  },
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    sizeStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showPopper: false,
      sideHeight: 0,
      popperHeight: 0,
      showFooter: false
    }
  },
  computed: {
    fixed() {
      return this.$store.getters.fixedMenu
    },
    atBottom() {
      return this.$store.getters.atBottom
    },
    footerStyle() {
      return {
        bottom: `${this.$store.getters.atBottom ? 45 - this.$store.getters.scrollBottom : 0}px`
      }
    },
    menus() {
      return this.$store.getters.menus
    },
    menusMap() {
      return this.$store.getters.menusMap
    },
    fixedMenus() {
      const fixedMenus = new Set(this.$store.getters.fixedMenus)
      return (this.$store.getters.menus.children || []).filter(menu => fixedMenus.has(`${menu.id}`))
    },
    popperOptions() {
      return {
        boundariesElement: document.body,
        preventOverflowOrder: ['left', 'right', 'bottom', 'top']
      }
    }
  },
  watch: {
    showPopper() {
      setTimeout(() => {
        this.$emit('size-change')
      }, 100)
    },
    menus() {
      this.changeSize()
    },
    fixedMenus() {
      this.changeSize()
    }
  },
  methods: {
    async changeSize(height = this.popperHeight) {
      await this.$nextTick()
      this.popperHeight = height
      this.sideHeight = Math.max(this.$refs.side.scrollHeight, this.popperHeight)
      await this.$nextTick()
      this.$emit('size-change')
    },
    changeFixed() {
      this.$store.commit('app/SET_FIXED_MENU', !this.fixed)
    },
    chooseMenu(menu) {
      if (this.$route.name === menu.vueUrl) return
      const route = this.$router.resolve({ name: menu.vueUrl }).route
      if ((!menu.vueUrl || !route.matched.length) && process.env.NODE_ENV !== 'production') {
        this.$message({ message: '无法跳转到指定页面，错误原因：1、菜单配置中url信息配置错误。2、当前页面没有编写完成。', type: 'warning' })
        return
      }
      this.$store.dispatch('menu/updateRecent', menu)
      this.$router.push({ name: menu.vueUrl })
      this.$emit('choose-menu', {})
    },
    footerShow() {
      this.$emit('size-change')
      this.$nextTick(() => {
        this.showFooter = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.side-box {
  width: 230px;
  background: #ffffff;
  transition: all .3s;
  min-height: calc(100vh - 95px);
  height: 100%;
  padding-bottom: 25px;
  &.no-fixed {
    position: absolute;
    top: 0;
    left: -230px;
    &.is-open {
      left: 0;
      box-shadow: 0px 5px 13px 0px rgba(106, 106, 106, 0.06);
    }
  }

  .fix-icon {
    cursor: pointer;
  }
  &-footer {
    display: none;
  }
  &:hover {
    .side-box-footer {
      box-sizing: border-box;
      background: #ffffff;
      width: 230px;
      position: fixed;
      bottom: 45px;
      display: block;
      padding: 0px 15px;
      color: #999;
      font-size: 14px;
      line-height: 45px;
    }
  }
}
</style>
